const { listAll } = require('./list-all')
const { toGenericQuantities: convert } = require('./../../tools')

exports.toGenericQuantities = (state, productQuantities) => {
  return listAll(state)
    .then((allProducts) => {
      return convert(productQuantities, allProducts)
    })
}
